export const sortAnamnese = <T extends { processed_at?: string | null }>(anamneses: T[]) : T[] => {
  return [...anamneses].sort((a, b) => new Date(b?.processed_at ?? 0).getTime() - new Date(a?.processed_at ?? 0).getTime());
};
